import { render, staticRenderFns } from "./FamousCommentItem.vue?vue&type=template&id=42c4d678&"
import script from "./FamousCommentItem.vue?vue&type=script&lang=js&"
export * from "./FamousCommentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports